module.exports = __webpack_public_path__ + "img/2_OG.3eed202b.png";